import React, { useEffect, useState } from "react";
import NewsCard from "../common/NewsCard";
import AdCard from "../common/AdCard";
import { getAdsForSection } from "../../config/ads";
import { Link } from "react-router-dom";

function ImmNewsSection({ title, articles, category }) {
  const SHOW_DATA = true; // 🔁 Change to false to show empty frame

  const [masterArticle, setMasterArticle] = useState(null);

  useEffect(() => {
    async function loadHomeMaster() {
      try {
        const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/homemasters`;
        const res = await fetch(apiUrl);
        const data = await res.json();

        const matched = data.find(
          (item) => item.HM_Section?.toLowerCase() === category?.toLowerCase()
        );

        setMasterArticle(matched || null);
      } catch (err) {
        console.error("HomeMaster API error:", err);
        setMasterArticle(null);
      }
    }

    if (SHOW_DATA) {
      loadHomeMaster();
    }
  }, [category, SHOW_DATA]);

  const isEmpty = !SHOW_DATA || !articles || articles.length === 0;

  const bigCard = !isEmpty ? masterArticle || articles[0] : null;
  const isMasterCard = !!masterArticle && SHOW_DATA;

  const gridArticles = !isEmpty
    ? isMasterCard
      ? articles.slice(0, 12)
      : articles.slice(1, 13)
    : [];

  const { ad1, ad2 } = getAdsForSection(category || title);

  return (
    <>
      <div style={{ marginBottom: "40px" }}>
        <div className="ns-section-title">{title}</div>

        {/* ================= ROW 1 ================= */}
        <div className="ns-row-1">
          <div className="ns-card ns-big-card">
            {bigCard ? (
              isMasterCard ? (
                <Link
                  to={`/homemaster/${bigCard.id}`}
                  className="ns-big-card-link"
                >
                  <BigCardContent bigCard={bigCard} isMasterCard />
                </Link>
              ) : (
                <BigCardContent bigCard={bigCard} isMasterCard={false} />
              )
            ) : (
              <div className="ns-empty-big-card" />
            )}
          </div>

          <div className="ns-ad-column">{ad1 && <AdCard ad={ad1} />}</div>
        </div>

        {/* ================= ROW 2 ================= */}
        <div className="ns-news-row">
          {gridArticles.length > 0
            ? gridArticles
                .slice(0, 4)
                .map((article, i) => (
                  <NewsCard key={`r2-${i}`} article={article} />
                ))
            : Array(4)
                .fill(0)
                .map((_, i) => (
                  <div key={`e2-${i}`} className="ns-empty-card" />
                ))}
        </div>

        {/* ================= ROW 3 ================= */}
        <div className="ns-news-row">
          {ad2 && <AdCard ad={ad2} />}
          {gridArticles.length > 0
            ? gridArticles
                .slice(4, 7)
                .map((article, i) => (
                  <NewsCard key={`r3-${i}`} article={article} />
                ))
            : Array(3)
                .fill(0)
                .map((_, i) => (
                  <div key={`e3-${i}`} className="ns-empty-card" />
                ))}
        </div>

        {/* ================= ROW 4 ================= */}
        <div className="ns-news-row">
          {gridArticles.length > 0
            ? gridArticles
                .slice(7, 11)
                .map((article, i) => (
                  <NewsCard key={`r4-${i}`} article={article} />
                ))
            : Array(4)
                .fill(0)
                .map((_, i) => (
                  <div key={`e4-${i}`} className="ns-empty-card" />
                ))}
        </div>
      </div>

      {/* ================= STYLES ================= */}
      <style>{`
        .ns-section-title {
          margin: 30px 0 10px;
          font-size: 22px;
          font-weight: bold;
          color: #1a1a1a;
        }

        .ns-card {
          background: #fff;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
          display: flex;
          flex-direction: column;
          height: 100%;
        }

        .ns-row-1 {
          display: grid;
          grid-template-columns: 3fr 1fr;
          gap: 15px;
          margin-bottom: 15px;
        }

        .ns-news-row {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 15px;
          margin-bottom: 15px;
        }

        .ns-big-card-content {
          display: flex;
          height: 100%;
        }

        .ns-big-card-image {
          flex: 0 0 40%;
          min-height: 300px;
        }

        .ns-big-card-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .ns-big-card-body {
          padding: 20px;
          display: flex;
          flex-direction: column;
        }

        .ns-big-card-title {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 12px;
          color: #222;
          line-height: 1.4;
        }

        .ns-big-card-desc {
          font-size: 14px;
          color: #666;
          line-height: 1.6;
        }

        /* Skeleton */
        .ns-empty-big-card,
        .ns-empty-card {
          border-radius: 10px;
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 37%,
            #f0f0f0 63%
          );
          background-size: 400% 100%;
          animation: shimmer 1.4s ease infinite;
        }

        .ns-empty-big-card {
          height: 300px;
        }

        .ns-empty-card {
          height: 250px;
        }

        @keyframes shimmer {
          0% { background-position: 100% 0; }
          100% { background-position: 0 0; }
        }

        /* Responsive */
        @media (max-width: 768px) {
          .ns-row-1 {
            grid-template-columns: 1fr;
          }

          .ns-news-row {
            grid-template-columns: 1fr 1fr;
          }

          .ns-big-card-content {
            flex-direction: column;
          }
        }

        @media (max-width: 480px) {
          .ns-news-row {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </>
  );
}

/* Big Card Content */
function BigCardContent({ bigCard, isMasterCard }) {
  return (
    <div className="ns-big-card-content">
      <div className="ns-big-card-image">
        <img
          src={isMasterCard ? bigCard.HM_Image : bigCard.image}
          alt={isMasterCard ? bigCard.HM_Title : bigCard.title}
        />
      </div>

      <div className="ns-big-card-body">
        <div className="ns-big-card-title">
          {isMasterCard ? bigCard.HM_Title : bigCard.title}
        </div>

        <div className="ns-big-card-desc">
          {isMasterCard ? bigCard.HM_Description : bigCard.description}
        </div>

        <a
          href={
            isMasterCard
              ? `/homemaster/${bigCard.id}`
              : bigCard.NewsSource || bigCard.link
          }
          target={isMasterCard ? "_self" : "_blank"}
          rel={isMasterCard ? "" : "noopener noreferrer"}
          style={{
            marginTop: "10px",
            fontSize: "14px",
            color: "#0066cc",
            fontWeight: 500,
            textDecoration: "none",
          }}
        >
          Read More →
        </a>
      </div>
    </div>
  );
}

export default ImmNewsSection;
